import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { CharonService, IHttpOptions, IInitializeParam, ILink } from "../../../../libs/charon";
@Injectable({
  providedIn: 'root'
})
export class CaronteCustodiaService {
  
  readonly ERROR_INITIALIZE = 'Falha inicializando o Caronte.';
  readonly ERROR_GETLINKS = 'Falha recuperando entrypoint.';
  sessionId: string | undefined;

  constructor(private charon: CharonService) {
    this.charon.setCryptography(environment.caronteCustodia.encrypted);
  }

  public initializeSession(): Promise<unknown> {
    const params: IInitializeParam = {
      charonID: environment.caronteCustodia.charonId,
      entryPoint: environment.caronteCustodia.entryPoint,
      headers: this.defaultHeaders()
    };

    return this.charon.initialize(params).toPromise();
  }

  public addEntrypont(rel: string): Observable<any> {
    const options: IHttpOptions = {
      headers: this.defaultHeaders()
    };

    return this.charon.get(rel, options);     
  }


  public executeRequest(rel: string, params?: Map<string, any>, body?: any): Observable<any> {
    const options: IHttpOptions = {
      headers: this.defaultHeaders(),
      params: this.getParams(params)
    };
        
    const link = this.getLink(rel);
    switch (link.method) {
      case 'GET':
        return this.charon.get(rel, options)
          .pipe(
            map((response: any) => response.body)
          );
      case 'POST':
        return this.charon.post(rel, body, options)
          .pipe(
            map((response: any) => response.body)
          );
      case 'PUT':
        return this.charon.put(rel, body, options)
          .pipe(
            map((response: any) => response.body)
          );
      case 'PATCH':
        return this.charon.patch(rel, body, options)
          .pipe(
            map((response: any) => response.body)
          );
      case 'DELETE':
        return this.charon.delete(rel, options)
          .pipe(
            map((response: any) => response.body)
          );
      default:
        throw new Error("Invalid method!");
    }
  }

  private generateGuid(): string {
    const getUUID = () =>
      (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          Number(c) ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))
        ).toString(16)
      );
    return getUUID();
  }

  private getParams(params?: Map<string, any>): HttpParams | undefined {
    if (params) {
      let parameters = new HttpParams();
      for (const [key, value] of params) {
        if (value) {
          parameters = parameters.set(key, value);
        }
      }
      return parameters;
    }
    return undefined;
  }

  private defaultHeaders(): HttpHeaders {
    return new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('x-itau-correlationid', this.generateGuid())
      .append('x-itau-apikey', environment.caronteCustodia.apiKey)
      .append('x-itau-no-virtualization', 'true');
  }

  private getLink(relation: string): ILink {
    const link = this.charon.getRelation(relation);

    if (link) {
      return link;
    }

    throw new Error(`Nenhum Link com a relation '${relation}' foi encontrado`);
  }
}